import React, { useState, useRef, useEffect } from 'react';
import { toast } from 'react-toastify';
import { checkverifyotpnegotiation } from '../../services/CommonService';
import ReviewHeader from './ReviewHeader';
import ReviewFooter from './ReviewFooter';
// import './OTPVerification.css';

const OTPVerification = ({ negotiationId, negotiationData, onVerifySuccess, recipientEmail }) => {
    const [otpValues, setOtpValues] = useState(["", "", "", "", "", ""]);
    const [loading, setLoading] = useState(false);
    const inputRefs = useRef([]);
    useEffect(() => {
        const otpVerified = sessionStorage.getItem(`otp_verified_${negotiationId}`);
        if (otpVerified === 'true') {
            onVerifySuccess();
        }
    }, [negotiationId, onVerifySuccess]);

    const handleOtpInput = (e, idx) => {
        let value = e.target.value.replace(/[^0-9]/g, '');
        if (value.length > 1) return;

        setOtpValues(prev => {
            const arr = [...prev];
            arr[idx] = value;
            return arr;
        });

        if (value && idx < 5) {
            inputRefs.current[idx + 1]?.focus();
        }
    };

    const handleOptClear = (e, idx) => {
        if (e.key === 'Backspace') {
            if (!otpValues[idx] && idx > 0) {
                inputRefs.current[idx - 1]?.focus();
            }
            setOtpValues(prev => {
                const arr = [...prev];
                arr[idx] = '';
                return arr;
            });
        }
    };

    const handlePasteValue = (e) => {
        let value = e.clipboardData.getData('text').replace(/[^0-9]/g, '');
        if (value.length === 6) {
            setOtpValues(value.split(''));
            setTimeout(() => {
                inputRefs.current[5]?.focus();
            }, 0);
        }
    };

    const handleOtpVerify = async () => {
        const otp = otpValues.join('');
        if (otp.length !== 6) {
            toast.error('Please enter valid 6-digit OTP');
            return;
        }

        if (!negotiationId) {
            toast.error("Negotiation ID not found, please reload");
            return;
        }

        try {
            setLoading(true);
            await checkverifyotpnegotiation({ id: negotiationId, otp, email:recipientEmail });
            toast.success('OTP Verified Successfully');
            sessionStorage.setItem(`otp_verified_${negotiationId}`, 'true');
            onVerifySuccess();
        } catch (err) {
            console.error(err);
            toast.error(err.response?.data?.message || 'Invalid OTP');
        } finally {
            setLoading(false);
        }
    };

    const handleResendOTP = () => {
        toast.info('OTP has been resent to your device');
        // Add your resend OTP API call here
    };

    return (
        <div className="review-otp-page">
            <ReviewHeader negotiationData={negotiationData} hideActions={true} />

            <div className="review-otp-verification-screen">
                <div className="review-otp-card">
                    <div className="review-otp-header">
                        <h2 className="review-otp-title">Verify Your Code</h2>
                        <p className="review-otp-subtitle">
                            Enter the 6-digit code sent to your device
                        </p>
                    </div>

                    <div className="review-otp-inputs-container">
                        {[0, 1, 2, 3, 4, 5].map((idx) => (
                            <input
                                key={idx}
                                type="text"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                className="review-otp-input"
                                value={otpValues[idx]}
                                maxLength={1}
                                onPaste={handlePasteValue}
                                ref={(el) => (inputRefs.current[idx] = el)}
                                onKeyDown={(e) => {
                                    handleOptClear(e, idx);
                                    if (e.key === "Enter" && otpValues.every((v) => v)) {
                                        handleOtpVerify();
                                    }
                                }}
                                onChange={(e) => handleOtpInput(e, idx)}
                                autoFocus={idx === 0}
                            />
                        ))}
                    </div>

                    <button
                        className={`review-otp-button ${loading || otpValues.some((v) => !v) ? 'review-otp-button-disabled' : ''}`}
                        onClick={handleOtpVerify}
                        disabled={loading || otpValues.some((v) => !v)}
                    >
                        {loading ? 'Verifying...' : 'Verify OTP'}
                    </button>

    
                </div>
            </div>

            <ReviewFooter negotiationData={negotiationData} />
        </div>
    );
};

export default OTPVerification;
